import { Label } from "@mui/icons-material";

const resolutionOptions = [
  { label: "720 PX", value: "P720" },
  { label: "1080 PX", value: "P1080" },
  { label: "2K", value: "K2" },
  { label: "4K", value: "K4" },
];

const typeOptions = [
  { label: "Screen", value: "TV" },
  { label: "Channel", value: "CHANNEL" },
];
const SCREEN_CARTEGORY_OPTIONS = [
  { label: "Basic", value: "BASIC" },
  { label: "Premimum", value: "PREMIUM" },
 
]

const SCREEN_SIZE_OPTIONS = [
  { label: "24", value: "I24" },
  { label: "32", value: "I32" },
  { label: "40", value: "I40" },
  { label: "43", value: "I43" },
  { label: "50", value: "I50" },
  { label: "55", value: "I55" },
  { label: "65", value: "I65" },
  { label: "75", value: "I75" },
  { label: "85", value: "I85" },
]

const orientationOptions = [
  { label: "Landscape", value: "LANDSCAPE" },
  { label: "Portrait", value: "PORTRAIT" }
]

const isPublicOptions = [
  { label: "True", value: true },
  { label: "False", value: false },
];



const formatHourRange = (hour: number) => {
  const format = (h: number) => {
    const period = h >= 12 ? "PM" : "AM";
    const displayHour = h % 12 === 0 ? 12 : h % 12;
    return `${displayHour} ${period}`;
  };

  const start = format(hour);
  const end = format((hour + 1) % 24);

  return `${start} – ${end}`;
};

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => ({
  label: formatHourRange(h),
  value: h,
}));

const DAYS = [
  { label: "Monday", value: "MON" },
  { label: "Tuesday", value: "TUE" },
  { label: "Wednesday", value: "WED" },
  { label: "Thursday", value: "THU" },
  { label: "Friday", value: "FRI" },
  { label: "Saturday", value: "SAT" },
  { label: "Sunday", value: "SUN" },
];

const DAY_TO_NUMBER: Record<string, string> = {
  MON: "1",
  TUE: "2",
  WED: "3",
  THU: "4",
  FRI: "5",
  SAT: "6",
  SUN: "7",
};


const DAY_OPTIONS = DAYS.map(day => ({
  label: day,
  value: day,
}));


export {
  resolutionOptions,
  orientationOptions,
  isPublicOptions,
  HOUR_OPTIONS,
  DAY_OPTIONS,
  typeOptions,
  DAYS,
  DAY_TO_NUMBER,
  SCREEN_CARTEGORY_OPTIONS,
  SCREEN_SIZE_OPTIONS,
  formatHourRange,
}
